import React, { useEffect, useState } from "react";

import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    Autocomplete,
    Box,
    Button,
    Card,
    Chip,
    ClickAwayListener,
    IconButton,
    InputAdornment,
    MenuItem,
    Paper,
    Popper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,

} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Clear } from "@mui/icons-material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import Pagination from "../../components/Pagination";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import { useDeleteActionTrackerMutation, useGetAllActionTrackerQuery } from "../../services/actionTracker";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import PermitUpdateModal from "../../components/UpdatePermitModal";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { getEnquriesCount, getFeedbackCount, getLeadsCount, getNewPropertyListing, getNewPropertyReports, getNewUsers, getRecentNotificationCount, setNotificationCount } from "../../reducers/generalSlice";
import { errorToast, successToast } from "../../helpers";
import WarnModal from "../../components/WarnModal";
import EditKeyModal from "../../components/EditWarnModal";
import CategorySelector from "../../components/CategorySelector";
import { useLazyGetAllCategoryQuery } from "../../services/category";
import { useLazyGetpropertYTypeListingQuery } from "../../services/property";
import { LISTING_TYPE, ROLE } from "../../constants/enums";
import QualityCriteria from "../../components/QualityScoreModal";
import { useLazyGetAllTypeOfCompaniesQuery } from "../../services/users";
type Criteria = {
    complete: string[],
    incomplete: string[]
}


const ListingActionTracker = () => {
    const [rows1, setRows1] = useState<any>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    let totalPages = Math.ceil(totalCount / limit);
    const [selectedId, setSelectedId] = useState<string>("")
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const onPageChange = (newPage: number) => {
        setPage(newPage);
        setRows1([]);
    };
    const [qualityScoreData, setQualityScoreData] = useState<Criteria>({
        complete: [],
        incomplete: []
    })
    const [deleteApi] = useDeleteActionTrackerMutation();
    const [deleteId, setDeleteId] = useState<string>("");
    const [openDelete, setOpenDelete] = useState<boolean>(false)
    const newUsers = useAppSelector(getNewUsers);
    const newPropertyReports = useAppSelector(getNewPropertyReports);
    const newPropertyListing = useAppSelector(getNewPropertyListing);
    const newFeedbackCount = useAppSelector(getFeedbackCount);
    const newEnquries = useAppSelector(getEnquriesCount)
    const newNotificationCount = useAppSelector(getRecentNotificationCount);
    const newLeadsCount = useAppSelector(getLeadsCount);
    const [fetchAllCategory] = useLazyGetAllCategoryQuery();
    const [propertyType, setPropertyType] = useState<string>("");
    const [category, setCategory] = useState<string>("");
    const [openEdit, setOpenEdit] = useState<boolean>(false);
    const [propertyTypeList] = useLazyGetpropertYTypeListingQuery();
    const [categoryDataNew, setCategoryDataNew] = useState<any>(
        []
    );
    const [agencyType, setAgencyType] = useState<any>("");
    const [companies, setCompanies] = useState<any>([]);
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [getApprovedCompany] = useLazyGetAllTypeOfCompaniesQuery();
    const [properties, setProperties] = useState<{ _id: string; name: string }[]>(
        []
    );
    const [selectedParentCategory, setSelectedParentCategory] = useState<any>("");
    const [visibleName, setVisibleName] = useState('Select category');
    const [listingType, setListingType] = useState<number | string>("");

    const handleCategoryReset = () => {
        setSelectedParentCategory('');
        setCategory('');
    };
    const [openCriteria, setOpenCriteria] = useState<boolean>(false);
    const onCloseCriteria = () => {
        setOpenCriteria(false)
    }
    const dispatch = useAppDispatch()
    const [open, setOpen] = useState<boolean>(false);
    const [open2, setOpen2] = useState(false); // Control calendar visibility
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [selectedChip, setSelectedChip] = useState("")
    const [month, setMonth] = useState(new Date());
    const [isRent, setIsRent] = useState<boolean>(false);
    const [isBuy, setIsBuy] = useState<boolean>(false);
    const [range, setRange] = useState<{
        from: Date | undefined;
        to: Date | undefined;
    }>({
        from: undefined,
        to: undefined,
    });


    const handleClose = () => {
        setOpen2(false);
    };


    const fetchCategories = async () => {
        try {
            const response = await fetchAllCategory({
                type: "both",
            }).unwrap();
            if (response?.statusCode === 200) {
                const data = response?.data.map((item: any) => {
                    return {
                        categoryName: item._id,
                        subCategory: {
                            [item._id._id]: item.categories,
                        },
                    };
                });
                setCategoryDataNew(data);
            }
        }
        catch (e: any) {
            errorToast(e?.message || e?.data?.message);
        }
    };

    const fetchPropertyType = async () => {
        try {
            const response = await propertyTypeList({}).unwrap();
            if (response?.statusCode === 200) {
                setProperties(response?.data?.propertyType || []);
            }
        } catch (e: any) {
            errorToast(e?.message || e?.data?.message);
        }
    };


    const fetchCompanies = async () => {
        try {
            const response = await getApprovedCompany({
                role: ROLE.AGENCY
            }).unwrap();
            if (response.statusCode === 200) {
                setCompanies(response?.data || []);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteRequest = async (userId: any) => {
        try {
            const response = await deleteApi({ id: userId }).unwrap();
            if (response?.statusCode === 200) {
                successToast("Action tracker deleted successfully");

            }
        } catch (error: any) {
            console.error(error);
            errorToast(error?.data?.message || "");
        }
    };



    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen2(true);
    };

    const getFormattedRange = () => {
        if (range?.from && range?.to) {
            return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
                range.to
            ).format("MM/DD/YYYY")}`;
        } else if (range?.from) {
            return moment(range.from).format("MM/DD/YYYY");
        }
        return "";
    };

    const handleSelect = (selectedRange: any) => {
        if (selectedRange === undefined) {
            setRange({ from: undefined, to: undefined });
        } else {
            setRange(selectedRange);
        }
    };

    const handleChipClick = (value: any) => {
        if (value === selectedChip) {
            setSelectedChip("");
            setRange({ from: undefined, to: undefined });
            setMonth(moment().toDate());
            return;
        }
        setSelectedChip(value);

        let newRange = { from: moment().toDate(), to: moment().toDate() };
        const today = moment();

        if (value === "lastMonth") {
            newRange = {
                from: moment().subtract(1, "months").startOf("month").toDate(),
                to: moment().subtract(1, "months").endOf("month").toDate(),
            };
        } else if (value === "lastWeek") {
            newRange = {
                from: moment().subtract(7, "days").startOf("day").toDate(),
                to: today.toDate(),
            };
        } else if (value === "lastYear") {
            newRange = {
                from: moment().subtract(1, "years").startOf("year").toDate(),
                to: moment().subtract(1, "years").endOf("year").toDate(),
            };
        }
        setRange(newRange);
        setMonth(newRange.from);
    };

    const handleMonthChange = (newMonth: any) => {
        setMonth(newMonth);
    };

    const naviagteFun = () => {
        setOpen(true)
    }

    function formatNumberWithCommas(value: string | number) {
        const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
        const [integer, decimal] = valueStr.split('.');
        const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
        return result;
    }

    const { data, isLoading, isError, isSuccess } = useGetAllActionTrackerQuery({
        page: page, search: debouncedSearchTerm.trim(), limit: limit,
        startDate: range?.from ? moment(range?.from).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
        endDate: range?.from === range?.to ? "" : range?.to ? moment(range?.to).utc().format("YYYY-MM-DDTHH:mm:ss[Z]") : "",
        listingType: Number(listingType) || "",
        agencyType: agencyType,
        propertyTypeId: isRent || isBuy ? "" : propertyType,
        categoryId: category,
        categoryParentId: selectedParentCategory,
        isBuy: isBuy,
        isRent: isRent,
        agentId: selectedCompany
    })







    useEffect(() => {
        if (isSuccess && data) {
            const res = data?.data;
            setRows1(res?.properties || []);
            setTotalCount(res?.count);
        }
    }, [isSuccess, data]);

    useEffect(() => {
        fetchPropertyType();
        fetchCategories();
        fetchCompanies();
    }, []);

    useEffect(() => {
        dispatch(
            setNotificationCount({
                newNotificationCount: newNotificationCount,
                newUsers: newUsers,
                newPropertyListing: newPropertyListing,
                newPropertyReports: newPropertyReports,
                newListingActionTracker: 0,
                newEnquriesCount: newEnquries,
                newFeedbackCount: newFeedbackCount,
                leadsCount: newLeadsCount
            })
        );
    }, []);


    return (
        <div>
            <Loader isLoad={isLoading} />
            <div className="main_loyout">
                <div className="dashboard">
                    <h1 className="mn_hdng">Property Listing Action Tracker {totalCount ? `(${totalCount})` : ""}</h1>
                </div>
                <Card className="cards">
                    <Box className="cards_header">
                        <Box className="cards_header_left">
                            <SearchBar2
                                value={searchTerm}
                                searchTerm={searchTerm}
                                onCross={() => setSearchTerm("")}
                                setDebouncedSearchTerm={setDebouncedSearchTerm}
                                onChange={(val: any) => {
                                    if (isValidInput(val.target.value)) {
                                        setSearchTerm(val.target.value);
                                        setTimeout(() => {
                                            setPage(1)
                                        }, 1000)
                                    }
                                }}
                            />
                            <div className="control_group" >
                                <TextField
                                    // label="Select Date Range"
                                    variant="outlined"
                                    hiddenLabel
                                    className="text_field-range"
                                    fullWidth
                                    onClick={handleClick}
                                    value={getFormattedRange()}
                                    placeholder="Select Date Range"
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: range?.from ? (
                                            <InputAdornment position="end" style={{ marginLeft: -50 }}>
                                                <IconButton
                                                    onClick={() => {
                                                        setRange({
                                                            from: undefined,
                                                            to: undefined
                                                        });
                                                    }}
                                                >
                                                    <Clear />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Popper
                                    open={open2}
                                    anchorEl={anchorEl}
                                    placement="bottom-start"
                                    disablePortal
                                    style={{
                                        position: "relative",
                                        zIndex: 1,
                                    }}
                                >
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <Paper elevation={3} style={{ position: "relative", zIndex: 1 }}>
                                            <div
                                                style={{
                                                    padding: 16,
                                                    borderRadius: 10,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-around",
                                                    }}
                                                >
                                                    <Chip
                                                        label="Last Week"
                                                        variant={selectedChip === "lastWeek" ? "filled" : "outlined"}
                                                        onClick={() => handleChipClick("lastWeek")}
                                                    />
                                                    <Chip
                                                        label="Last Month"
                                                        variant={selectedChip === "lastMonth" ? "filled" : "outlined"}
                                                        onClick={() => handleChipClick("lastMonth")}
                                                    />
                                                    <Chip
                                                        label="Last Year"
                                                        variant={selectedChip === "lastYear" ? "filled" : "outlined"}
                                                        onClick={() => handleChipClick("lastYear")}
                                                    />
                                                </div>

                                                <DayPicker
                                                    className="react-day-picker"
                                                    mode="range"
                                                    selected={range}
                                                    onSelect={handleSelect}
                                                    // numberOfMonths={10}
                                                    month={month}
                                                    onMonthChange={handleMonthChange}
                                                // styles={{
                                                //   months: { display: "flex", gap: "16px" },
                                                //   month: { margin: 0 },
                                                // }}
                                                />
                                            </div>
                                        </Paper>
                                    </ClickAwayListener>
                                </Popper>
                            </div>
                        </Box>
                        <div className="Filters_div mb_20">
                            <div className="childFilter childfilter1">
                                <Select
                                    className="select_div"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={propertyType}
                                    // onChange={(e) => setPropertyType(e.target.value)}
                                    onChange={(e) => {
                                        const selectedProperty = properties?.find((it: any) => it?._id === e.target.value);

                                        if (selectedProperty?.name === "Rent") {
                                            setIsRent(true);
                                            setIsBuy(false);
                                            setPropertyType(e.target.value);
                                        } else if (selectedProperty?.name === "Buy") {
                                            setIsBuy(true)
                                            setIsRent(false);
                                            setPropertyType(e.target.value);
                                        } else {
                                            setPropertyType(e.target.value);
                                            setIsRent(false);
                                            setIsBuy(false);
                                        }
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select Property Type
                                    </MenuItem>
                                    {properties?.length > 0
                                        ? properties?.map((it: any) => (
                                            <MenuItem key={it?._id} value={it?._id}>
                                                {it?.name}
                                            </MenuItem>
                                        ))
                                        : ""}
                                </Select>
                            </div>
                            <div className="childFilter ">

                                <CategorySelector
                                    categoryData={categoryDataNew}
                                    handleReset={handleCategoryReset}
                                    category={category}
                                    parentCategory={selectedParentCategory}
                                    setCategory={setCategory}
                                    visibleName={visibleName}
                                    setVisibleName={setVisibleName}
                                    setParentCategory={setSelectedParentCategory}
                                />

                            </div>
                            <div className="childFilter childfilter1">
                                <Select
                                    className="select_div"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={listingType}
                                    onChange={(e) => setListingType(Number(e.target.value))}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select Listing
                                    </MenuItem>

                                    <MenuItem value="1">Standard </MenuItem>
                                    <MenuItem value="3">Premium</MenuItem>
                                    <MenuItem value="2">Featured</MenuItem>
                                </Select>
                            </div>
                            <div className="childFilter childfilter1">
                                <Select

                                    value={agencyType}
                                    onChange={(e) => setAgencyType(e.target.value)}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select company type
                                    </MenuItem>
                                    <MenuItem value="1">Real estate broker</MenuItem>
                                    <MenuItem value="2">Short-term rentals</MenuItem>
                                </Select>
                            </div>
                            <Autocomplete
                                options={companies || []}
                                disableClearable
                                getOptionLabel={(option: any) => option?.companyName + " (" + option?.referenceId + ")" || ""}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Company"
                                        variant="outlined"
                                    />
                                )}
                                value={
                                    companies?.find(
                                        (it: any) => it?._id === selectedCompany
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    setSelectedCompany(newValue?._id || "");
                                }}
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option?._id === value?._id
                                }
                            />
                            {propertyType !== "" ||
                                category !== "" ||
                                selectedParentCategory !== "" ||
                                listingType !== "" ||
                                isRent || isBuy || selectedCompany ||
                                agencyType !== "" ? (
                                <Button
                                    className="btn btn_primary mt_20"
                                    onClick={() => {
                                        setPropertyType("");
                                        setCategory("");
                                        setAgencyType("");
                                        setListingType("");
                                        setVisibleName("Select category");
                                        setSelectedParentCategory("");
                                        setIsBuy(false)
                                        setIsRent(false)
                                        setSelectedCompany("")
                                    }}
                                >
                                    Clear filters
                                </Button>
                            ) : (
                                ""
                            )}
                        </div>
                    </Box>
                    <TableContainer className="table_container">
                        <Box className="heading"></Box>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.No</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                    <TableCell>Image</TableCell>
                                    <TableCell>Badges</TableCell>
                                    <TableCell>Property Id</TableCell>
                                    <TableCell>Reference No.</TableCell>
                                    <TableCell>Property Name</TableCell>
                                    <TableCell>Quality Score</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Agent Name</TableCell>
                                    <TableCell>Company Name</TableCell>
                                    <TableCell>Listing Type</TableCell>
                                    <TableCell>Boost Property</TableCell>
                                    <TableCell>Property Category</TableCell>
                                    <TableCell>Property Type</TableCell>
                                    <TableCell>Permit number</TableCell>
                                    <TableCell>Expiry Date</TableCell>
                                    <TableCell>Date & time</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows1.length === 0 ? (
                                    <TableCell colSpan={7} align="center">
                                        No Expired document property found
                                    </TableCell>
                                ) : (rows1?.map((row: any, i: any) => (
                                    <TableRow key={row.i}>
                                        <TableCell align="center">
                                            {(page - 1) * 10 + i + 1}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Box className="table_actions">

                                                <Tooltip title="Update records">
                                                    <IconButton
                                                        // onClick={() => { setSelectedId(row?.propertyId); setOpen(true) }
                                                        // }

                                                        onClick={() => {
                                                            setOpenEdit(true);
                                                            setSelectedId(row?._id);
                                                        }}
                                                    >
                                                        <ModeEditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete record">
                                                    <IconButton
                                                        onClick={() => {
                                                            setOpenDelete(true);
                                                            setDeleteId(row?._id);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>

                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <figure className="user_img">
                                                <img
                                                    src={
                                                        row?.properties?.images?.[0] ||
                                                        `/static/images/product1.png`
                                                    }
                                                    alt=""
                                                />
                                            </figure>
                                        </TableCell>
                                        <TableCell align="center">
                                            <figure
                                                className="user_img"
                                            >

                                                {row?.properties?.isVerified ? (
                                                    <img className="property_badge" src="/static/images/verfy_icon.svg" alt="" />
                                                ) : ("")}
                                                {row?.properties?.qualityScore >= 80 ? (
                                                    <img src="/static/images/verify_ico.svg" alt="" />
                                                ) : ("")}
                                                {row?.properties?.isPropertyBoost ? (
                                                    <img src="/static/images/boost.png" alt="" />
                                                ) : ("")}

                                            </figure>
                                        </TableCell>
                                        <TableCell>{row?.properties?.referenceId || "-"}</TableCell>
                                        <TableCell>{row?.properties?.import_reference_number || "-"}</TableCell>
                                        <TableCell>{row?.properties?.name || "-"}</TableCell>
                                        <TableCell style={{ cursor: "pointer" }} onClick={() => {
                                            if (row?.properties?.qualityScoreMeetCriteria?.length) {
                                                setQualityScoreData({
                                                    complete: row?.properties?.qualityScoreMeetCriteria || [],
                                                    incomplete: row?.properties?.qualityScorePendingCriteria || []
                                                })
                                                setOpenCriteria(true)
                                            }

                                        }}>{row?.properties?.qualityScore || "-"}</TableCell>
                                        <TableCell>{row?.properties?.price ? formatNumberWithCommas(row?.properties?.price) : "-"}</TableCell>
                                        <TableCell>{row?.agentId?.role === ROLE.AGENT ? row?.agentId?.name + " (" + row?.agentId?.referenceId + ")" : "-"}</TableCell>
                                        <TableCell>{row?.companyId?.companyName ? row?.companyId?.companyName + " (" + row?.companyId?.referenceId + ")" : "-"
                                        }</TableCell>
                                        <TableCell>{row?.properties?.listingType ? LISTING_TYPE[row?.properties?.listingType] : "-"}</TableCell>
                                        <TableCell>{row?.properties?.isPropertyBoost ? "Yes" : "No"}</TableCell>
                                        <TableCell>{row?.category?.name || "-"}</TableCell>
                                        <TableCell>
                                            {row?.propertyType?.name || "-"}
                                        </TableCell>
                                        <TableCell>
                                            {row?.advertisementPermitNo || "-"}

                                        </TableCell>

                                        <TableCell>{row?.endDate ? moment(row?.endDate).format("LLL") : "-"
                                        }</TableCell>
                                        <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell>

                                    </TableRow>
                                )))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </div>
            {rows1?.length > 0 ? (
                <Pagination
                    setPage={setPage}
                    module={rows1}
                    limit={limit}
                    setLimit={setLimit}
                    page={page}
                    onPageChange={onPageChange}
                    totalPages={totalPages}
                />
            ) : (
                ""
            )}
            <PermitUpdateModal
                open={open}
                setOpen={setOpen}
                id={selectedId}
            />
            <WarnModal
                open={openDelete}
                setOpen={setOpenDelete}
                handleDelete={() => handleDeleteRequest(deleteId)}
                name="Action tracker"
            />
            <EditKeyModal
                open={openEdit}
                setOpen={setOpenEdit}
                navigate={naviagteFun}
            />
            <QualityCriteria
                open={openCriteria}
                setOpen={setOpenCriteria}
                onClose={onCloseCriteria}
                data={qualityScoreData}
            />
        </div>
    );
};

export default ListingActionTracker;
